import React from 'react'
import { useSelector} from 'react-redux';
import { Link } from 'react-router-dom';
const AdminLeftSideBar = ({ adminLogoUserImg, adminLogoUserName }) => {
const showLeftSideBar = useSelector(state => state.adminToogle.adminToogleAction)
    return (
        <>
            {/* <div className='containerAdmin'> */}
           
                
                    <div className='adminLeft' >
                    <div className='adminSideBarBlock'>
                        <p className='adminLogo'>Rewards Connect</p>
                        <div className='adminLogoUser'>
                            <div className='adminLogoUserImg'>
                                <img src={adminLogoUserImg} alt='img' />
                            </div>
                            <div className='adminLogoUserName'>
                                <p>{adminLogoUserName}</p>
                            </div>
                        </div>
                        <nav className="nav" role="navigation">

                            <ul className="nav__list">
                                <li>
                                    <input id="group-1" type="checkbox" hidden />
                                    <label htmlFor="group-1"><Link to= '/event-list'>Event</Link></label>
                                    {/* <ul className="group-list">
                                        <li><a href="#">1st level item</a></li>
                                        <li>
                                            <input id="sub-group-1" type="checkbox" hidden />
                                            <label htmlFor="sub-group-1"><span className="fa fa-angle-right"></span> Second level</label>
                                            <ul className="sub-group-list">
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li>
                                                    <input id="sub-sub-group-1" type="checkbox" hidden />
                                                    <label htmlFor="sub-sub-group-1"><span className="fa fa-angle-right"></span> Third level</label>
                                                    <ul className="sub-sub-group-list">
                                                        <li><a href="#">3rd level nav item</a></li>
                                                        <li><a href="#">3rd level nav item</a></li>
                                                        <li><a href="#">3rd level nav item</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul> */}
                                </li>
                                {/* <li>
                                    <input id="group-2" type="checkbox" hidden />
                                    <label htmlFor="group-2"><span className="fa fa-angle-right"></span> First level</label>
                                    <ul className="group-list">
                                        <li>
                                            <li><a href="#">1st level item</a></li>
                                            <li><a href="#">1st level item</a></li>
                                            <input id="sub-group-2" type="checkbox" hidden />
                                            <label htmlFor="sub-group-2"><span className="fa fa-angle-right"></span> Second level</label>
                                            <ul className="sub-group-list">
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li>
                                                    <input id="sub-sub-group-2" type="checkbox" hidden />
                                                    <label htmlFor="sub-sub-group-2"><span className="fa fa-angle-right"></span> Third level</label>
                                                    <ul className="sub-sub-group-list">
                                                        <li><a href="#">3rd level nav item</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <input id="group-3" type="checkbox" hidden />
                                    <label htmlFor="group-3"><span className="fa fa-angle-right"></span> First level</label>
                                    <ul className="group-list">
                                        <li>
                                            <li><a href="#">1st level item</a></li>
                                            <li><a href="#">1st level item</a></li>
                                            <input id="sub-group-3" type="checkbox" hidden />
                                            <label htmlFor="sub-group-3"><span className="fa fa-angle-right"></span> Second level</label>
                                            <ul className="sub-group-list">
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li>
                                                    <input id="sub-sub-group-3" type="checkbox" hidden />
                                                    <label htmlFor="sub-sub-group-3"><span className="fa fa-angle-right"></span> Third level</label>
                                                    <ul className="sub-sub-group-list">
                                                        <li><a href="#">3rd level nav item</a></li>
                                                        <li><a href="#">3rd level nav item</a></li>
                                                        <li><a href="#">3rd level nav item</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <input id="group-4" type="checkbox" hidden />
                                    <label htmlFor="group-4"><span className="fa fa-angle-right"></span> First level</label>
                                    <ul className="group-list">
                                        <li>
                                            <li><a href="#">1st level item</a></li>
                                            <input id="sub-group-4" type="checkbox" hidden />
                                            <label htmlFor="sub-group-4"><span className="fa fa-angle-right"></span> Second level</label>
                                            <ul className="sub-group-list">
                                                <li><a href="#">2nd level nav item</a></li>
                                                <li><a href="#">2nd level nav item</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li> */}
                            </ul>
                        </nav>

                    </div>
                </div>
           
            

            

        </>
    )
}

export default AdminLeftSideBar